import nativeCreate from "./_nativeCreate.js";
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {}, this.size = 0;
}
export {
  hashClear as default
};
//# sourceMappingURL=_hashClear.js.map
